var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a"},[_c('van-swipe',{attrs:{"autoplay":3000,"indicator-color":"white"}},_vm._l((_vm.banner),function(item,index){return _c('van-swipe-item',{key:index,attrs:{"height":100,"width":100}},[_c('img',{attrs:{"src":item.banner.thumb_url,"alt":""},on:{"click":function($event){return _vm.go(item.banner.url)}}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }